import { createSvgComponent } from "../../icon/createSvgComponent";
import Link from "@core/__generated__/icon/figma/link.svg";
export default createSvgComponent(Link);